import { useState } from 'react';
import { canShareFiles, download, shareFile } from '../lib/share';
import { errorText } from '../lib/errors';
import type { Receipts } from '../lib/types';

const art = () => import('../lib/receiptArt');

/**
 * A receipt PDF, drawn on the phone from the server's record when asked for. Where the phone can share files, the
 * finished PDF is then one tap from WhatsApp (iPhones only share straight from a tap), or saved.
 */
export function ReceiptButton({ load, kind, label, className = 'btn ghost sm' }: {
  load: () => Promise<Receipts>;
  kind: 'order' | 'event';
  label: string;
  className?: string;
}) {
  const [made, setMade] = useState<{ blob: Blob; name: string } | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const share = canShareFiles();

  async function make() {
    setBusy(true);
    setError(null);
    try {
      const data = await load();
      const a = await art();
      const r = kind === 'order' ? await a.orderReceiptPdf(data) : await a.eventReceiptsPdf(data);
      setMade(r);
      if (!share) download(r.blob, r.name);
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  }

  if (made && share) {
    return (
      <div className="share-row" style={{ justifyContent: 'flex-start' }}>
        <button type="button" className="btn primary sm" onClick={() => void shareFile(made.blob, made.name)}>Share receipt</button>
        <button type="button" className="btn ghost sm" onClick={() => download(made.blob, made.name)}>Save PDF</button>
      </div>
    );
  }
  return (
    <>
      <button type="button" className={className} style={className.includes('block') ? undefined : { justifySelf: 'start' }} disabled={busy}
        onClick={() => (made ? download(made.blob, made.name) : void make())}>
        {busy ? 'Preparing receipt…' : label}
      </button>
      {error && <p className="err">{error}</p>}
    </>
  );
}
